var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"text-area",domProps:{"innerHTML":_vm._s(_vm.content)}})])]),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }